
import { defineComponent } from 'vue'
import { useError } from '@/composable/useError'

export default defineComponent({
  name: 'AppErrorModal',

  setup() {
    return useError()
  },
})
